import {
  IconNameEnum,
  useHotelsStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import type { TripAdvisorComment } from "@b2bportal/lodging-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { useCustomerReview } from "@tenant/hotels";
import { Icon, TripadvisorRatingIcon } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./CustomerReview.module.scss";

export interface CustomerReviewComponentProps extends PlatformComponentProps {
  review: TripAdvisorComment;
  showTripAdvisorRating?: boolean;
  showSeeFullReview?: boolean;
  showReviewInfo?: boolean;
  onSeeFullReview?: () => void;
}

const COMPONENT_KEY = CoreHotelsComponent.CustomerReview;

export const CustomerReviews = (props: CustomerReviewComponentProps) => {
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const {
    showTripAdvisorRating,
    showReviewInfo,
    className,
    showSeeFullReview = false,
    onSeeFullReview,
  } = props;

  const { context, text } = useCustomerReview(props);
  const { t } = useI18nContext();

  const handleSeeFullReviewClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    onSeeFullReview?.();
  };

  return (
    <div className={clsx(block, className)}>
      <div className={cn("title")}>{text.title}</div>
      {showTripAdvisorRating && (
        <div className={cn("rating-icon")}>
          <Icon
            className={cn("tripadvisor-icon")}
            iconName={IconNameEnum.tripadvisor}
          />
          <TripadvisorRatingIcon scoreOutOfFive={context.rating} />
        </div>
      )}
      <div className={cn("review", { summary: showSeeFullReview })}>
        {text.content.map((line, index) => (
          <p key={index}>{line}</p>
        ))}
      </div>
      {showSeeFullReview && (
        <a
          href="#"
          className={cn("see-full-review")}
          onClick={handleSeeFullReviewClick}
        >
          {t("core-hotels.shop.customerReviews.seeFullReview")}
        </a>
      )}
      {showReviewInfo && (
        <div className={cn("review-info")}>{text.reviewInfo}</div>
      )}
    </div>
  );
};
